import BaseCrudService from '@/services/base-crud-service'
import taskConfig from '@/config/task-config'
import axiosHttp from '@/utilities/axios-http'

class TaskService extends BaseCrudService {
  updateCompleted = (id, completed) => {
    return axiosHttp.patch(`${this.resourcePath}/${id}/completed`, {
      completed
    })
  }

  indexDiscussions = discussable_id => {
    return axiosHttp.get(
      `${this.resourcePath}/${discussable_id}/${taskConfig.API_DISCUSSIONS_PATH}`
    )
  }

  storeDiscussion = (discussable_id, payload) => {
    return axiosHttp.post(
      `${this.resourcePath}/${discussable_id}/${taskConfig.API_DISCUSSIONS_PATH}`,
      payload
    )
  }

  updateDiscussion = (discussable_id, id, payload) => {
    return axiosHttp.patch(
      `${this.resourcePath}/${discussable_id}/${taskConfig.API_DISCUSSIONS_PATH}/${id}`,
      payload
    )
  }

  deleteDiscussion = (discussable_id, id) => {
    return axiosHttp.delete(
      `${this.resourcePath}/${discussable_id}/${taskConfig.API_DISCUSSIONS_PATH}/${id}`
    )
  }
}

export default new TaskService(taskConfig.API_RESOURCE)
